import React from 'react';
import { Mail, Phone, Linkedin, MapPin, Calendar, MessageCircle } from 'lucide-react';
import { triggerSubtleConfetti } from '../utils/confetti';
import { createWhatsAppUrl } from '../utils/whatsapp';
import { trackEvent, EVENTS } from '../utils/posthog';
const ContactSection: React.FC = () => {
  const handleContactClick = (e: React.MouseEvent, contactType: string) => {
    triggerSubtleConfetti(e.currentTarget);
    // Track contact method click
    trackEvent(EVENTS[`${contactType.toUpperCase()}_CLICKED`], {
      contact_type: contactType,
      location: 'contact_section'
    });
  };
  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.preventDefault();
    triggerSubtleConfetti(e.currentTarget);
    // Track WhatsApp click
    trackEvent(EVENTS.WHATSAPP_CLICKED, {
      location: 'contact_section',
      message_type: 'recruiter_template'
    });
    // Pre-filled recruiter message template
    const message = `Hi Mona, I came across your profile and would like to discuss a job opportunity we have at:
- Company Name: [Your Company]
- Job Title: [Position Title]
- Compensation: [Salary Range]
Next Steps:
1. Please reply with your availability for a brief call
2. Share any questions you have about the role
3. We can schedule a formal interview
Looking forward to connecting!`;
    const whatsappUrl = createWhatsAppUrl('+358458426661', message);
    window.open(whatsappUrl, '_blank');
  };
  return <section id="contact" className="py-16 bg-gradient-to-b from-cream-white to-sage-mint/5" data-id="element-279">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-280">
        <div className="text-center mb-12" data-id="element-281">
          <h2 className="text-2xl md:text-3xl font-light text-charcoal mb-4" data-id="element-282">
            Contact & Availability
          </h2>
          <p className="text-grey-600 max-w-2xl mx-auto" data-id="element-283">
            Based in Singapore and available for immediate opportunities in
            healthcare facilities across the region
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-284">
          {/* Email */}
          <a href="mailto:mona.sudarat31@gmail.com" className="bg-white rounded-xl p-6 shadow-card hover:shadow-glow-mint transition-all duration-300 group" onClick={e => handleContactClick(e, 'email')} data-id="element-285">
            <div className="flex items-center mb-4" data-id="element-286">
              <div className="w-12 h-12 rounded-full bg-sage-mint/10 flex items-center justify-center group-hover:bg-sage-mint/20 transition-colors duration-300" data-id="element-287">
                <Mail className="h-6 w-6 text-sage-mint" data-id="element-288" />
              </div>
            </div>
            <h3 className="text-lg font-medium text-charcoal mb-2" data-id="element-289">Email</h3>
            <p className="text-sm text-grey-600 break-words" data-id="element-290">
              mona.sudarat31@gmail.com
            </p>
          </a>
          {/* WhatsApp */}
          <button onClick={handleWhatsAppClick} className="bg-white rounded-xl p-6 shadow-card hover:shadow-glow-mint transition-all duration-300 group text-left" data-id="element-291">
            <div className="flex items-center mb-4" data-id="element-292">
              <div className="w-12 h-12 rounded-full bg-sage-mint/10 flex items-center justify-center group-hover:bg-sage-mint/20 transition-colors duration-300" data-id="element-293">
                <MessageCircle className="h-6 w-6 text-sage-mint" data-id="element-294" />
              </div>
            </div>
            <h3 className="text-lg font-medium text-charcoal mb-2" data-id="element-295">WhatsApp</h3>
            <p className="text-sm text-grey-600" data-id="element-296">+358 45 8426661</p>
            <p className="text-xs text-sage-mint mt-2" data-id="element-297">
              Click to message with template
            </p>
          </button>
          {/* LinkedIn */}
          <a href="https://www.linkedin.com/in/sudarat-mona-bunthawee-69357b171/?profileId=ACoAACjXUQ8BeMFvnmB8Kwcz6JlKsh88uED_CUs" target="_blank" rel="noopener noreferrer" className="bg-white rounded-xl p-6 shadow-card hover:shadow-glow-mint transition-all duration-300 group" onClick={e => handleContactClick(e, 'linkedin')} data-id="element-298">
            <div className="flex items-center mb-4" data-id="element-299">
              <div className="w-12 h-12 rounded-full bg-sage-mint/10 flex items-center justify-center group-hover:bg-sage-mint/20 transition-colors duration-300" data-id="element-300">
                <Linkedin className="h-6 w-6 text-sage-mint" data-id="element-301" />
              </div>
            </div>
            <h3 className="text-lg font-medium text-charcoal mb-2" data-id="element-302">LinkedIn</h3>
            <p className="text-sm text-grey-600" data-id="element-303">View Profile</p>
          </a>
          {/* Location */}
          <div className="bg-white rounded-xl p-6 shadow-card hover:shadow-glow-mint transition-all duration-300 group cursor-default" onClick={handleContactClick} data-id="element-304">
            <div className="flex items-center mb-4" data-id="element-305">
              <div className="w-12 h-12 rounded-full bg-sage-mint/10 flex items-center justify-center group-hover:bg-sage-mint/20 transition-colors duration-300" data-id="element-306">
                <MapPin className="h-6 w-6 text-sage-mint" data-id="element-307" />
              </div>
            </div>
            <h3 className="text-lg font-medium text-charcoal mb-2" data-id="element-308">Location</h3>
            <p className="text-sm text-grey-600" data-id="element-309">Singapore</p>
          </div>
        </div>
        {/* Availability notice */}
        <div className="mt-12 bg-white rounded-xl p-6 shadow-card text-center" data-id="element-310">
          <div className="flex items-center justify-center mb-4" data-id="element-311">
            <Calendar className="h-6 w-6 text-sage-mint mr-2" data-id="element-312" />
            <h3 className="text-lg font-medium text-charcoal" data-id="element-313">
              Immediate Availability
            </h3>
          </div>
          <p className="text-grey-600 max-w-2xl mx-auto" data-id="element-314">
            Available for full-time positions in Singapore healthcare
            facilities. Open to roles in geriatric care, psychiatric nursing,
            emergency departments, and general medical-surgical units. Willing
            to work flexible schedules including nights and weekends.
          </p>
        </div>
      </div>
    </section>;
};
export default ContactSection;